import { useQuery } from '@tanstack/react-query';
import { useFetch } from '@/shared/hooks/useFetch';
import { useMutate } from '@/shared/hooks/useMutate';
import { queryKeys } from '@/shared/api/queryKeys';
import {
  apiReportCancel,
  apiReportDone,
  apiReportsList,
  apiReportsPendingCount,
} from '@/entities/reports/modules/api/reports';
import type { ApiReportsListParams } from '@/shared/types/api/reports';

export const useReports = (params: ApiReportsListParams) =>
  useFetch({
    api: () => apiReportsList(params),
    keywords: queryKeys.reports.list(params),
    staleTime: 30_000,
  });

export const useReportsPendingCount = (enabled = true) =>
  useQuery({
    queryKey: queryKeys.reports.pendingCount,
    queryFn: apiReportsPendingCount,
    enabled,
    refetchInterval: false,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
  });

export const useReportDone = () =>
  useMutate({
    api: (id: number) => apiReportDone(id),
    invalidateKeys: [queryKeys.reports.all, queryKeys.reports.pendingCount],
  });

export const useReportCancel = () =>
  useMutate({
    api: (id: number) => apiReportCancel(id),
    invalidateKeys: [queryKeys.reports.all, queryKeys.reports.pendingCount],
  });
